import { arrowDownShortcut } from './arrow-down';

export const arrowRightShortcut = {
  key: new Set(['ArrowRight']),
  callBackFunction: () => {
    arrowDownShortcut.callBackFunction();
  },
};
